"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.MCP_TOKENS, (table)=>{
        table.string('id', 20).primary();
        table.string('title', 512);
        table.string('base_id', 20);
        table.string('token', 32);
        table.string('fk_workspace_id', 20);
        table.float('order');
        table.string('fk_user_id', 20);
        table.timestamps(true, true);
        table.index([
            'base_id',
            'fk_workspace_id'
        ], 'nc_mc_tokens_context');
    });
};
const down = async (knex)=>{
    await knex.schema.dropTableIfExists(_globals.MetaTable.MCP_TOKENS);
};
